/** Workspace lifecycle, settings defaults and invitation rules. */

import { DEFAULT_CURRENCY, DEFAULT_TIMEZONE_FALLBACK } from "./config";
import { DEFAULT_INVOICE_PAGE_SIZE } from "./invoice";

export const WORKSPACE_STATUSES = {
  active: "active",
  archived: "archived",
} as const;

export type WorkspaceStatus = (typeof WORKSPACE_STATUSES)[keyof typeof WORKSPACE_STATUSES];

export const WORKSPACE_DEFAULTS = {
  invoicePrefix: "INV",
  invoicePageSize: DEFAULT_INVOICE_PAGE_SIZE,
  currency: DEFAULT_CURRENCY,
  timezone: DEFAULT_TIMEZONE_FALLBACK,
  taxPercent: 0,
  namePlaceholder: "My business",
} as const;

export const INVITATION_RULES = {
  ttlDays: 7,
  tokenBytes: 24,
  resendCooldownSeconds: 60,
} as const;

export const WORKSPACE_SLUG_SUFFIX_LENGTH = 4 as const;

export const WORKSPACE_SELECTOR = {
  searchDebounceMs: 250,
  maxRecent: 5,
} as const;

export const ANALYTICS_DEFAULTS = {
  rangeDays: 30,
  seriesBuckets: ["day", "week", "month"] as const,
  topProductLimit: 5,
} as const;

export type SeriesBucket = (typeof ANALYTICS_DEFAULTS.seriesBuckets)[number];

export const DEFAULT_SERIES_BUCKET: SeriesBucket = "day";
